export default "__VITE_ASSET__C1LRUbDi__"